import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import StringInput from '../../../components/inputs/StringInput'
import { AppContext } from '../../../contexts/AppContext'

const ConsumptionPointDetailsStep: React.FC<{
	streetAddress: string
	city: string
	zipCode: string
	meteringPoint: any
}> = ({ streetAddress, city, zipCode, meteringPoint }) => {
	const { isDarkMode } = useContext(AppContext)
	const { t } = useTranslation('modals_createContract', {
		keyPrefix: 'consumptionPointDetailsStep',
	})

	const disabledColor = isDarkMode ? '#ffffff' : '#000000'

	return (
		<div className='container'>
			<StringInput
				readonly
				disabledColor={disabledColor}
				value={`${streetAddress}, ${city} ${zipCode}`}
				label={t('address')}
			/>
			<StringInput
				readonly
				disabledColor={disabledColor}
				value={meteringPoint?.MeteringPointEAN}
				label={t('gsrn')}
			/>
		</div>
	)
}

export default ConsumptionPointDetailsStep
